import { render, staticRenderFns } from "./FormPopup.vue?vue&type=template&id=5b846cab&"
import script from "./FormPopup.vue?vue&type=script&lang=js&"
export * from "./FormPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports